import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,

    avatar: null
  },
  mutations: {
    INIT_RENAME_AVATAR_DIALOG(state, payload) {
      state.visibility = true
      state.avatar = payload
    },
    SET_RENAME_AVATAR_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_RENAME_AVATAR_DIALOG(state) {
      state.visibility = false
      state.avatar = null
    },
    SET_RENAME_AVATAR_DIALOG_AVATAR(state, payload) {
      state.avatar = payload
    }
  },
  actions: {
    async renameAvatar({ rootState, state, commit }, name) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.renaming'), loading: true })
        commit('SET_RENAME_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const { avatar_id } = state.avatar

        const response = await api.updateVideoAvatar({ params: { device_id, avatar_id, name } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.rename'), icon: 'check', timeout: '2000' })
          commit('RESET_RENAME_AVATAR_DIALOG')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_RENAME_AVATAR_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
